// extracted by mini-css-extract-plugin
export default {"avatar":"initials-icon_avatar__i6jy6"};